<template>
  <v-app id="inspire">
    <v-main style="height: 100vh; overflow: hidden">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

      <!-- Layout principal dividido -->
      <v-row no-gutters class="fill-height">
        <!-- Lateral esquerda (20% da tela) - Lista vertical de próximas senhas -->
        <v-col cols="3" class="d-flex flex-column fill-height" style="background-color: #0e1f31; border-right: 1px solid rgba(255,255,255,0.1);">
          <div style="flex: 1; overflow-y: auto; overflow-x: hidden;">
            <v-col cols="12" v-for="(chamada, index) in listaChamadas.slice(1, 5)" :key="index" class="mt-5 px-3">
              <senha :chamada="chamada" :user="user"></senha>
              <div v-if="chamada.nomePaciente" class="white--text text-center title font-weight-bold mt-1">
                {{ nomeFormatado(chamada.nomePaciente) }}
              </div>
              <v-divider v-show="index != 3" class="my-2" style="background-color: white; opacity: 0.3" />
            </v-col>
          </div>
          <v-card rounded="0" flat class="d-flex mt-1" color="primary" dark style="width: 100%;">
            <v-list-item>
              <v-list-item-content class="text-center">
                <!-- Data formatada (mais destacada) -->
                <div class="text-h5 mb-2">
                  {{ dataFormatada }}
                </div>

                <!-- Hora atual (destaque principal) -->
                <v-list-item-title class="text-h2 font-weight-bold mb-2">
                  {{ currentTime }}
                </v-list-item-title>

                <!-- Dia da semana (destaque secundário) -->
                <v-list-item-subtitle class="text-h4">
                  {{ diaDaSemana }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <!-- Divisor vertical -->

        <!-- Área principal (80% da tela) dividida horizontalmente -->
        <v-col cols="9" class="d-flex flex-column fill-height" style="position: relative;">
          
          <!-- Video/IPTV Overlay -->
          <div v-show="!mostrarChamadas" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 10; background: black;">
            <div id="player" style="width: 100%; height: 100%;"></div>
            <iptv v-if="isTelevisao" :isTelevisao="isTelevisao" :link="link" :iptvVolume="volumeVideo" @iptvPausa="iptvPausa" @carregarInfoIptv="carregarInfoIptv" />
          </div>

          <div class="d-flex flex-column fill-height" v-show="mostrarChamadas">
            <!-- Parte superior (70%) - Senha principal -->
            <div class="flex-grow-1 d-flex align-center justify-center" style="width: 100%;">
              <div style="width: 100%; height: 100%;">
                <!-- Chamada atual - Guichê -->
                <div v-if="listaChamadas.length > 0 && listaChamadas[0].tipoChamada == 0" style="height: 100%;">
                  <v-card rounded="0" flat color="white" height="100%">
                    <v-row align="center" justify="center" style="height: 100%; margin: 0;">
                      <!-- Conteúdo da senha principal -->
                      <v-col cols="6" class="mb-5 pb-5">
                        <div class="display-3 text-center pb-5">
                          <p v-if="listaChamadas[0].prioridade == 1 || listaChamadas[0].prioridade == 3"
                            :class="brilhar ? 'teal--text' : ''">
                            Prioridade
                          </p>
                          <p v-else :class="brilhar ? 'primary--text' : ''">
                            Convencional
                          </p>
                        </div>

                        <div class="display-3 font-weight-bold text-center pt-5">
                          <h1 :class="brilhar ? 'primary--text' : ''">
                            {{ listaChamadas[0].codigoSigla ? listaChamadas[0].codigoSigla : mapearLetraPrioridade(listaChamadas[0].prioridade) }}{{ listaChamadas[0].codigo }}
                          </h1>
                        </div>
                      </v-col>

                      <v-col cols="6" class="pt-5 mt-5">
                        <div class="display-3 text-center">
                          <p v-if="!!Number(listaChamadas[0].guiche) || listaChamadas[0].guiche == 0"
                            :class="brilhar ? 'primary--text' : ''">
                            Guichê
                          </p>
                          <p v-else :class="brilhar ? 'primary--text' : ''">
                            Local
                          </p>
                        </div>

                        <v-card-text class="headline font-weight-bold text-center">
                          <div v-if="!Number(listaChamadas[0].guiche) && listaChamadas[0].guiche != 0"
                            class="display-2 pt-2 font-weight-bold">
                            <h1 :class="brilhar ? 'primary--text mt-5 mb-5' : 'mt-5 mb-5'">
                              {{ listaChamadas[0].guiche }}
                            </h1>
                          </div>

                          <div v-else class="display-4 font-weight-bold center">
                            <h1 :class="brilhar ? 'primary--text' : ''">
                              {{ listaChamadas[0].guiche }}
                            </h1>
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
                <!-- CHAMADA MÉDICO/TÉCNICO - VERSÃO MELHORADA -->
                <div v-if="listaChamadas.length > 0 && listaChamadas[0].tipoChamada == 1" style="height: 100%;">
  <v-card flat height="100%" :color="brilhar ? 'primary darken-1' : 'primary'">
    <v-container fill-height fluid class="pa-0 d-flex flex-column">

      <!-- Parte Superior: Paciente -->
      <v-card flat :color="brilhar ? 'primary darken-1' : 'primary'" class="pa-6 d-flex flex-column align-center justify-center" style="flex: 1;">
        <v-avatar size="150" class="mb-4">
          <v-img :src="require('../assets/userIcon2.png')" contain />
        </v-avatar>

        <div class="text-center">
          <h1 :class="{ 'text--glow': brilhar, 'white--text': true }"
              class="display-2 font-weight-bold mb-2">
            {{ nomeFormatado(listaChamadas[0].nomePaciente) }}
          </h1>
        </div>
      </v-card>

      <!-- Parte Inferior: Informações -->
      <v-card
  flat
  :color="brilhar ? 'primary lighten-2' : 'primary lighten-1'"
  class="d-flex flex-column justify-center align-center text-center pa-6 mt-2"
  style="width: 100%; min-height: 400px;"
>
  <!-- Seção Local -->
  <div class="mb-8">
    <h2 class="display-1 mb-2 d-flex align-center justify-center">
      <v-icon left class="mr-2">mdi-map-marker</v-icon>
      Local
    </h2>
    <p v-if="listaChamadas[0].nomeConsultorio" :class="{ 'text--glow': brilhar }" class="display-2 font-weight-bold mb-2">
      {{ listaChamadas[0].nomeConsultorio }}
    </p>
    <p :class="{ 'text--glow': brilhar }" class="display-2 font-weight-bold">
      {{ listaChamadas[0].nomeLocal }}
    </p>
  </div>

  <v-divider class="my-4" style="width: 60%;"></v-divider>

  <!-- Seção Profissional -->
  <div>
    <h2 class="display-1 mb-2 d-flex align-center justify-center">
      <v-icon left class="mr-2">mdi-stethoscope</v-icon>
      Atendimento
    </h2>
    <p :class="{ 'text--glow': brilhar }" class="display-2 font-weight-bold">
      {{ listaChamadas[0].tecnico ? nomeFormatado(listaChamadas[0].nomeMedico) :
        (listaChamadas[0].tecnico == 0 ? 'Dr(a). ' + nomeFormatado(listaChamadas[0].nomeMedico) :
          nomeFormatado(listaChamadas[0].nomeMedico)) }}
    </p>
  </div>
</v-card>


    </v-container>
  </v-card>
</div>

              </div>
            </div>

            <!-- Divisor horizontal -->
            <v-divider></v-divider>

            <!-- Parte inferior (30%) - Logo -->
            <div style="height: 20%; min-height: 150px; display: flex; justify-content: flex-end; align-items: center; padding: 20px; background-color: #0e1f31;">
              <v-spacer />

              <v-img
                        src="@/assets/DRmed-03.png"
                        alt="DrMedPro"
                        class="logo-toolbar"
                        max-height="350"
                        max-width="450"
                    ></v-img>
              <v-btn title="Logout" text large icon color="primary" @click="logout()">
                <v-icon title="Logout">logout</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Diálogos e alertas -->
      <v-row justify="center">
        <v-dialog v-model="aguardandoConexao" width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Aguardando conexão...
              <v-progress-linear indeterminate color="white" class="mb-0" />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

      <v-alert color="#A5D6A7" :value="notificacaoMedicoOnline" type="success" transition="scale-transition">
        <h2 v-if="mensagemTecnicoNotificacao" class="display-1">
          {{ mensagemNomeMedicoNotificacao }} já se encontra pronto para atendimento no {{ mensagemNomeLocalNotificacao
          }}
        </h2>
        <h2 v-else class="display-1">
          Dr(a). {{ mensagemNomeMedicoNotificacao }} já se encontra pronto para atendimento no {{
            mensagemNomeLocalNotificacao }}
        </h2>
      </v-alert>
    </v-main>
  </v-app>
</template>
<script>
// import Cookies from 'js-cookie'
import {
  getToken,
  setToken
} from '../store/auth'
import visorService from '../services/visor.service'
// import telegramService from '../services/telegramBot.service'
import socketService from '../services/socket.service'
// import speech from 'speech-synth'
import telegramBotService from '../services/telegramBot.service'
import iptv from '../components/painel/iptv.vue'
import youtube from '../components/painel/youtube'
import {
  baseURL
} from '../../src/services/config'
import AnuncioImagem from '../components/painel/anuncioImagem.vue'
import senha from '../components/painel/senha.vue'
// import HelloWorld from '/components/HelloWorld.vue'

export default {
  name: 'Painel',
  components: {
    senha,
    iptv,
    youtube,
    AnuncioImagem
  },

  data () {
    return {
      selectedVoice: '', // 15 provavelmente é o valor para indioma brasileiro,
      synth: window.speechSynthesis,
      mandouMsgErroAudio: false,
      anuncios: [],
      baseUrl: baseURL,
      diaDaSemana: '',
      dataFormatada: '',
      mLink: '',
      token: getToken(),
      imagensAnuncios: [],
      linkImg: '',
      iAnuncios: null,
      indexAnuncio: 0,
      isYoutube: false,
      voiceList: [],
      greetingSpeech: new window.SpeechSynthesisUtterance(),
      URL_AUDIO: 'http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3',
      executandoAudio: true,
      usuario: {},
      modoVisualizacao: '',
      visorGuiche: false,
      dialogAudio: false,
      videoPlayer: '',
      mostrarChamadas: true,
      isTelevisao: 0,
      isTelevisaoAtiva: 0,
      player: null,
      intevalVolumeIptv: 0,
      iptvErroTime: false,
      videoId: '',
      chamouVideoOffline: false,
      disponivel: false,
      videoId2: 'A-Fcy7uQ-mk',
      valid: false,
      brilhar: false,
      horario: '0:0',
      volumeVideo: 0,
      idVideo: '',
      link: '-jCiDGuR5hI',
      nomeVideo: '',
      socket: '',
      intervalos: [],
      currentTime: null,
      mensagemNotificacaoSocket: 'default',
      mensagemNomeMedicoNotificacao: '',
      mensagemNomeLocalNotificacao: '',
      mensagemTecnicoNotificacao: 0,
      aguardandoConexao: false,
      entrouEmAguardandoConexao: false,
      exibindoMensagensVisor: false,
      fila1MensagensVisor: [],
      fila2MensagensVisor: [],
      filaNotificacaoMedicoOnline: [],

      executandoAudioTimeout: false,
      listaAudio1: [],
      listaAudio2: [],
      executandoListaAudio1: false,
      executandoListaAudio2: false,

      IntervalExecutandoAudioTimeoutMethod: '',
      intervalMostrarChamadas: '',

      notificacaoMedicoOnline: false,
      notificacao: false,
      IframeAPIReady: false,
      user: '',
      listaChamadas: [],
      date: new Date().getHours() + ':' + new Date().getMinutes(),
      listaChamadasAux: [{
        codigo: '000',
        prioridade: 0,
        codigoSigla: 'C',
        guiche: '0',
        tipoChamada: 0
      },
      {
        codigo: '000',
        prioridade: 0,
        codigoSigla: 'C',
        guiche: '0',
        tipoChamada: 0
      },
      {
        codigo: '000',
        prioridade: 0,
        codigoSigla: 'C',
        guiche: '0',
        tipoChamada: 0
      },
      {
        codigo: '000',
        prioridade: 0,
        codigoSigla: 'C',
        guiche: '0',
        tipoChamada: 0
      },
      {
        codigo: '000',
        prioridade: 0,
        codigoSigla: 'C',
        guiche: '0',
        tipoChamada: 0
      },
      {
        codigo: '000',
        prioridade: 0,
        codigoSigla: 'C',
        guiche: '0',
        tipoChamada: 0
      }
      ]
    }
  },
  watch: {

    reload: function (val) {
      if (!this.reload) {
        setTimeout(() => {
          this.forceRerender()
        }, 10000)
      }
    },
    mostrarChamadas: function (val) {
      if (val && this.isTelevisao) {
        if (!this.isResetVideo) {
          // console.log('---222222')
          this.isResetVideo = true
          this.time = setTimeout(() => {
            if (this.mostrarChamadas) {
              this.iptvErroTime = true
              this.$nextTick(() => {
                this.iptvErroTime = false
              })
              console.log('Resetou')
            }
            this.isResetVideo = false
          }, 600000)
        }
      }
    }
  },

  created () {
    var i1 = setInterval(() => this.iniciarContador(), 1000)
    // var i2 = setInterval(this.addMensagensVisorDelay, 200);
    var i2 = setInterval(this.verificarListaAudios, 300)
    var i3 = setInterval(this.refreshToken, 28800000)
    var i4 = setInterval(() => this.atualizarPainel(), 20 * 1000)
    // var i5 = setInterval(() => this.pausarPlayVideo(), 120 * 1000)
    // var i6 = setInterval(() => this.verificarSocketAlterarVideo(), 5000);
    // var i7 = setInterval(
    //   () => this.verificacaoPeriodicaEstadoVideo(),
    //   3 * 60 * 1000
    // )
    var i8 = setInterval(this.verificarFilaNotificacaoMedico, 2000)
    this.intervalos.push(i1)
    this.intervalos.push(i2)
    this.intervalos.push(i3)
    this.intervalos.push(i4)
    // this.intervalos.push(i5)
    // this.intervalos.push(i6)
    // this.intervalos.push(i7)
    this.intervalos.push(i8)
  },
  beforeDestroy: function () {
    this.limparIntervalos()
  },
  mounted () {
    this.user = this.$store.getters.usuario
    // this.link = this.user.link  // descomentar essa parte dps
    console.log('user', this.user)
    this.retornarAnuncios()
    if (this.user.tipo != 6) {
      this.$router.push('/login')
      return
    }

    if (!this.user.primeiroAcesso) {
      this.$store.dispatch('SetPrimeiroAcessoPainel', 1)
      // this.$store.dispatch("VideoId", this.link)
      // this.$store.dispatch("Reloads", 1)
      location.reload()
    }

    this.socket = io.connect(socketService.SOCKET_URL, {
      query: {
        token: getToken()
      }
    })

    this.listenForSpeechEvents()
    this.chamarSocket()
    this.retornarChamadas()
    // this.retornarInfoPainel()
    this.voiceList = this.synth.getVoices()

    if (this.voiceList.length) {
      this.executandoAudio = false
    }

    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices()
      setTimeout(() => {
        this.executandoAudio = false
      }, 800)
    }
    this.atualizarData()
  },

  methods: {
    atualizarData () {
      const agora = new Date()
      const meses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      // Formata a data (Dia de Mês de Ano)
      const dia = agora.getDate()
      const mes = meses[agora.getMonth()]
      const ano = agora.getFullYear()
      this.dataFormatada = `${dia} de ${mes} de ${ano}`

      // Dia da semana
      const dias = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira',
        'Quinta-feira', 'Sexta-feira', 'Sábado']
      this.diaDaSemana = dias[agora.getDay()]
    },
    verificarIptvYoutube (link) {
      if (link.includes('youtube')) {
        let mLink = link.split('=')
        // let link2 = mLink[3].split('=')
        // let link3 = link2[1].split('&')
        // console.log(mLink)
        this.mLink = mLink[1]
        if (this.mostrarChamadas) this.mostrarChamadas = false
        return mLink[1]
      }
      return false
    },
    stopAnuncioImagem () {
      this.linkImg = ''
    },
    erroYoutube (link) {
      console.log(link)
      // this.youtubeStop()
      if (this.anuncios.length > 1) {
        this.anuncios.forEach((element, i) => {
          if (element.link === link) {
            this.anuncios.splice(i, 1)
          }
        })
      } else {
        // clearTimeout(this.iAnuncios)
      }
      // this.iAnuncios.clearTimeout()
    },
    youtubePlay (data) {
      console.log('youtubePlay ----', data)
      if (!this.executandoAudioTimeout) {
        this.isYoutube = true
        this.executandoAudioTimeout = true
      }
    },
    youtubeStop () {
      this.isYoutube = false
      this.executandoAudioTimeout = false
      if ((this.anuncios.length - 1) > this.indexAnuncio) {
        this.indexAnuncio += 1
      } else if ((this.anuncios.length - 1) == this.indexAnuncio) {
        this.indexAnuncio = 0
      }
    },
    retornarAnuncios () {
      visorService.visor
        .retornarAnuncios().then(r => {
          if (r.status == 200) {
            console.log(r.data)
            this.anuncios = r.data
            if (this.anuncios.length > 0) {
              this.anuncios.forEach((e, i) => {
                if (this.anuncios[i].tipo === 'imagem') {
                  this.imagensAnuncios.push(e)
                  setInterval(() => {
                    this.linkImg = e.link
                  }, e.intervaloReproducao * 60000)
                }
              })
              if (this.imagensAnuncios.length > 0) {

              }
              if (this.anuncios[this.indexAnuncio]) {
                this.iAnuncios = setInterval(() => {
                  if (this.anuncios[this.indexAnuncio].tipo === 'video') {
                    this.isYoutube = true
                  }
                }, this.anuncios[this.indexAnuncio].intervaloReproducao * 60000)
              }
            }
          }
        })
    },
    audioError (local, username) {
      telegramBotService.telegram
        .audioError(local, username)
        .then(rsp => {
          console.log('retorno audioError telegram:', rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarChamadas () {
      visorService.visor
        .retornarChamadas()
        .then(rsp => {
          console.log('retorno retornarChamadas:', rsp.data)
          this.listaChamadas = rsp.data.map(chamada => {
            if (!chamada.codigoSigla) {
              chamada.codigoSigla = this.mapearLetraPrioridade(chamada.prioridade)
            }
            return chamada
          })
          this.carregarMensagens()
          this.retornarInfoPainel()
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    chamarVideoOffline (idVideo, nomeVideo, link) {
      if (this.isTelevisao) {
        if (!this.chamouVideoOffline && this.disponivel) {
          this.videoOffline(idVideo, nomeVideo, link)
          this.chamouVideoOffline = true
        }
      }
    },

    videoOffline (idVideo, nomeVideo, link) {
      visorService.visor
        .videoOffline(idVideo, nomeVideo, link)
        .then(rsp => {
          console.log('retorno videoOffline:', rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },
    iptvPausa (data) {
      this.isTelevisao = 0
      this.isTelevisaoAtiva = 0
      this.mostrarChamadas = true
      setTimeout(() => {
        this.isTelevisao = 1
        this.isTelevisaoAtiva = 1
        this.mostrarChamadas = false
      }, 1800000)
    },
    carregarInfoIptv (data) {
      console.log('chamando ---', data)
      if (data) {
        this.isTelevisaoAtiva = 1
        this.mostrarChamadas = false
        this.isResetVideo = false
        clearTimeout(this.time)
      } else {
        this.isTelevisaoAtiva = 0
        this.mostrarChamadas = true
      }
    },
    carregarInfoVideo () {
      // Carregar a API do YouTube dinamicamente
      var tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      var firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

      // Definir as funções de callback globais da API do YouTube
      window.onYouTubeIframeAPIReady = () => {
        // Criação do player após o carregamento da API
        this.player = new YT.Player('player', {
          videoId: this.link,
          width: '100%', // largura
          height: 680, // altura
          playerVars: {
            autoplay: 1,
            controls: 1,
            autohide: 1,
            showinfo: 1,
            loop: 1,
            muted: 0
          },
          events: {
            onReady: this.onPlayerReady,
            onError: this.onPlayerError
          }
        })
      }

      // Função chamada quando o player estiver pronto
      window.onPlayerReady = (event) => {
        console.log('onPlayerReady status:', this.player.getPlayerState())
        event.target.playVideo()
        event.target.unMute()

        this.isTelevisao === 1 ? (this.mostrarChamadas = false) : (this.mostrarChamadas = true)
        this.player.setVolume(this.volumeVideo)

        setTimeout(() => {
          this.verificarEstadoVideoLogin()
        }, 8000)
      }

      // Função chamada em caso de erro no player
      window.onPlayerError = () => {
        console.log('Erro onPlayerError status:', this.player.getPlayerState())
        this.isTelevisaoAtiva = 0
        this.mostrarChamadas = true
      }
    },

    retornarInfoPainel () {
      visorService.visor
        .retornarInfoPainel()
        .then((rsp) => {
          console.log('rsp info Video:', rsp.data)

          // Garantir que rsp.data[0] existe antes de tentar acessar
          const painelData = (rsp.data && rsp.data[0]) || {}

          // Usar valores padrão para os dados
          this.isTelevisao = painelData.isTelevisao !== undefined ? painelData.isTelevisao : 0
          this.volumeVideo = painelData.volume !== undefined ? painelData.volume : 0
          this.modoVisualizacao = painelData.modoVisualizacao || ''
          this.link = painelData.link || 'error'
          this.idVideo = painelData.idVideo !== undefined ? painelData.idVideo : 0
          this.nomeVideo = painelData.nomeVideo || ''
          this.disponivel = painelData.disponivel !== undefined ? painelData.disponivel : 0
          this.volume = painelData.volume !== undefined ? painelData.volume : 0

          // Determinar estado da televisão
          this.isTelevisaoAtiva = this.isTelevisao === 1 ? 1 : 0

          // Tratamento adicional caso isTelevisao seja 0
          if (this.isTelevisao === 0) {
            this.link = 'error'
          }
        })
        .catch((err) => {
          console.error('Erro ao carregar informações do painel:', err)

          // Tratar caso precise exibir algo na interface
          this.link = 'error' // Definir link padrão em caso de erro
        })
    },

    verificaEstadoVideoSocket () {
      console.log('player status socket', this.player.getPlayerState())
      if (
        this.player.getPlayerState() == -1 ||
        this.player.getPlayerState() == 0
      ) {
        this.isTelevisaoAtiva = 0
        this.player.setVolume(0)
        this.mostrarChamadas = true
      }
    },

    verificarEstadoVideoLogin () {
      console.log('em verificarEstadoVideoLogin', this.player.getPlayerState())
      if (
        this.player == null ||
        this.player.getPlayerState() == -1 ||
        this.player.getPlayerState() == 0
      ) {
        console.log('entrou if verificarEstadoVideoLogin..')
        this.isTelevisaoAtiva = 0
        this.player.setVolume(0)
        this.mostrarChamadas = true
      }
    },

    criarFrame () {
      console.log('video')
    },

    tempoExibirTelaChamada () {
      this.mostrarChamadas = true
      // let volume = this.volumeVideo
      this.volumeVideo = 0
      // this.intevalVolumeIptv(tempo)
      // this.player.setVolume(0)
      // Re-enable after 6 seconds
      clearInterval(this.intervalMostrarChamadas)
      this.intervalMostrarChamadas = setTimeout(() => {
        // this.player.setVolume(this.volumeVideo)
        this.volumeVideo = this.volume
        this.mostrarChamadas = false
      }, 14000)
    },

    buscaVozPortugues () {
      // Filtra as vozes por idioma 'pt-BR' e nome 'Maria'
      const vozesFiltradas = this.voiceList.filter(voz => voz.lang === 'pt-BR' && voz.name.includes('Maria'))

      // Retorna a voz 'Maria' se disponível, caso contrário, retorna todas as vozes em português brasileiro
      return vozesFiltradas.length > 0 ? vozesFiltradas : this.voiceList.filter(voz => voz.lang === 'pt-BR')
    },

    brilharMensagemVisor () {
      for (let i = 0; i < 10; i++) {
        setTimeout(
          function () {
            if (i % 2 == 0) {
              this.brilhar = true
            } else {
              this.brilhar = false
            }
          }.bind(this),
          i * 500
        )
      }
    },

    refreshToken () {
      visorService.visor
        .refreshToken(getToken())
        .then(rsp => {
          if (rsp.status == 200) {
            setToken(rsp.data.token)
            this.socket.close()
            this.socket = io.connect(socketService.SOCKET_URL, {
              query: {
                token: getToken()
              }
            })
            this.chamarSocket()
          } else {
            this.logout()
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err)
          this.logout()
        })
    },

    limparIntervalos () {
      console.log('limpar intervalos')
      this.intervalos.forEach(clearInterval)
    },

    chamarModalConexao () {
      console.log('em chamarModalConexao..')

      if (this.mensagemNotificacaoSocket == 'aguardando conexao') {
        console.log('em if aguard conex')
        this.aguardandoConexao = true
        this.entrouEmAguardandoConexao = true
      }
      if (this.mensagemNotificacaoSocket == 'conectado') {
        this.aguardandoConexao = false
        if (this.entrouEmAguardandoConexao) {
          this.retornarChamadas()
          this.entrouEmAguardandoConexao = false
        }
      } else if (this.mensagemNotificacaoSocket == 'desconectado') {
        this.aguardandoConexao = true
      }
    },

    nomeFormatado (str) {
      if (!str) return ''
      var arr = str.split(' ')
      if (arr[1] != null) {
        var preposicao = arr[1].toLowerCase()
        if (
          preposicao == 'de' ||
          preposicao == 'da' ||
          preposicao == 'das' ||
          preposicao == 'do' ||
          preposicao == 'dos'
        ) {
          preposicao = true
        } else {
          preposicao = false
        }
      }
      return arr.slice(0, preposicao ? 3 : 2).join(' ')
    },

    carregarMensagens () {
      this.listaChamadasAux.forEach(element => {
        this.listaChamadas.push(element)
      })
    },

    playSound (sound) {
      if (sound) {
        var audio = new Audio(
          require('../assets/Air Plane Ding-SoundBible.com-496729130.mp3')
        )
        var playPromise = audio.play()
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.warn('Reprodução de áudio bloqueada pelo navegador (Autoplay Policy):', error)
          })
        }
      }
    },

    verificarFilaNotificacaoMedico () {
      if (
        this.filaNotificacaoMedicoOnline.length &&
        !this.notificacaoMedicoOnline
      ) {
        this.filaNotificacaoMedicoOnline.forEach((element, index) => {
          setTimeout(
            function timer1 () {
              this.notificacaoMedicoOnline = true
              this.mensagemNomeMedicoNotificacao = element.nomeMedico
              this.mensagemNomeLocalNotificacao = element.nomeLocal
              this.mensagemTecnicoNotificacao = element.tecnico
              setTimeout(
                function timer2 () {
                  this.notificacaoMedicoOnline = false
                  // this.filaNotificacaoMedicoOnline.splice(index, 1);
                }.bind(this),
                7000
              )
            }.bind(this),
            index * 8000
          )
        })
        this.filaNotificacaoMedicoOnline = []
      }
    },

    executandoAudioTimeoutMethod (int) {
      this.executandoAudioTimeout = true
      clearInterval(this.IntervalExecutandoAudioTimeoutMethod)
      // Re-enable after 6 seconds
      this.IntervalExecutandoAudioTimeoutMethod = setTimeout(() => {
        this.executandoAudioTimeout = false
      }, int * 1000)
    },

    executarListaAudio1 (listaAudio) {
      if (listaAudio.length) {
        this.executandoListaAudio1 = true
        var tempo
        if (listaAudio[0].tipoChamada == 1 || listaAudio[0].tipoChamada == 2) {
          // chamada medc
          tempo = 10
          this.listaChamadas.unshift(listaAudio[0])
          this.greet(2)
        } else {
          // chamada recep
          tempo = 9
          this.listaChamadas.unshift(listaAudio[0])
          this.greet(1)
        }
        setTimeout(
          function () {
            var listAux = listaAudio.slice(1)
            this.executarListaAudio1(listAux)
          }.bind(this),
          tempo * 1000
        )
      } else {
        this.listaAudio1 = []
        // this.executandoAudioTimeout = false
        this.executandoListaAudio1 = false
        console.log('fim executarListaAudio1', this.listaAudio1)
      }
    },

    executarListaAudio2 (listaAudio) {
      if (listaAudio.length) {
        this.executandoListaAudio2 = true
        var tempo

        if (listaAudio[0].tipoChamada == 1 || listaAudio[0].tipoChamada == 2) {
          // chamada medc
          tempo = 10
          this.listaChamadas.unshift(listaAudio[0])
          this.greet(2)
        } else {
          // chamada recep
          tempo = 9
          this.listaChamadas.unshift(listaAudio[0])
          this.greet(1)
        }
        setTimeout(
          function () {
            var listAux = listaAudio.slice(1)
            this.executarListaAudio2(listAux)
          }.bind(this),
          tempo * 1000
        )
      } else {
        this.listaAudio2 = []
        // this.executandoAudioTimeout = false
        this.executandoListaAudio2 = false

        console.log('fim executarListaAudio2', this.listaAudio2)
      }
    },

    verificarListaAudios () {
      if (
        this.listaAudio1.length &&
        !this.executandoAudioTimeout &&
        !this.executandoListaAudio2
      ) {
        this.executandoAudioTimeout = true
        console.log('entrou aqui 1')
        this.executarListaAudio1(this.listaAudio1)
      } else if (
        this.listaAudio2.length &&
        !this.executandoAudioTimeout &&
        !this.executandoListaAudio1
      ) {
        this.executandoAudioTimeout = true
        console.log('entrou aqui 2')
        this.executarListaAudio2(this.listaAudio2)
      }
    },

    greet (index) {
      console.log('em greet executar som...')
      this.playSound('http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3')

      if (this.isTelevisaoAtiva) {
        this.tempoExibirTelaChamada()
      }

      this.brilharMensagemVisor()

      let text = index === 1 ? '. comparecer ao guichê' : 'comparecer a'
      if (!Number(this.listaChamadas[0].guiche)) {
        text = index === 1 ? '. comparecer a' : 'comparecer a'
      }

      // Construção do texto de saudação
      if (index === 1) {
        this.executandoAudioTimeoutMethod(10)
        // const prioridades = ['C', 'P', 'B', 'A']
        // const prioridadeTexto = prioridades[this.listaChamadas[0].prioridade] || 'C'
        this.greetingSpeech.text = `senha ,${this.listaChamadas[0].codigoSigla || this.mapearLetraPrioridade(this.listaChamadas[0].prioridade)} ${' , '} ${this.listaChamadas[0].codigo} ${text} ${this.listaChamadas[0].guiche}.`
      } else if (index === 2) {
        this.executandoAudioTimeoutMethod(12)
        if (this.listaChamadas[0].tipoChamada === 2) {
          this.greetingSpeech.text = `${this.nomeFormatado(this.listaChamadas[0].nomePaciente)}.${text} ${this.listaChamadas[0].nomeLocal} `
        } else {
          const consultorio = this.listaChamadas[0].nomeConsultorio ? this.listaChamadas[0].nomeConsultorio + ' ' : ''
          this.greetingSpeech.text = `${this.nomeFormatado(this.listaChamadas[0].nomePaciente)}.${text} ${consultorio}`
        }
      }

      // Verificação e seleção da voz
      const vozesDisponiveis = this.buscaVozPortugues()
      if (vozesDisponiveis.length > 0) {
        this.greetingSpeech.voice = vozesDisponiveis[0]
        console.log('Voz selecionada:', vozesDisponiveis[0])
      } else {
        console.error('Nenhuma voz portuguesa disponível.')
        return // Encerra a função se nenhuma voz for encontrada
      }

      this.greetingSpeech.rate = 0.7
      this.greetingSpeech.pitch = 1

      // Execução da fala
      console.log(this.modoVisualizacao)
      this.synth.speak(this.greetingSpeech)
      if (['medico', 'recepcao-medico'].includes(this.modoVisualizacao)) {
        console.log('Executando fala:', this.greetingSpeech.text)
        this.synth.speak(this.greetingSpeech)
      } else {
        console.log('Modo de visualização não permite execução da fala:', this.modoVisualizacao)
      }
    },

    atualizarPainel () {
      var date = new Date() // Create a Date object to find out what time it is
      if (date.getHours() === 0 && date.getMinutes() == 30) {
        // Check o harario para atualizar
        console.log('atualizou painel')
        // this.retornarChamadas();
        this.limparIntervalos()
        location.reload()
      }
    },

    pausarPlayVideo () {
      var date = new Date()
      if (this.isTelevisaoAtiva == 1) {
        if (date.getHours() === 19 || date.getHours() === 1) {
          this.player.pauseVideo()
        } else if (date.getHours() === 5) {
          this.player.playVideo()
        }
      }
    },

    verificacaoPeriodicaEstadoVideo () {
      console.log('verfic periodica,status', this.player.getPlayerState())
      var date = new Date()
      if (
        date.getHours() > 6 &&
        date.getHours() < 18 &&
        this.isTelevisaoAtiva == 1
      ) {
        if (
          this.player.getPlayerState() == -1 ||
          this.player.getPlayerState() == 0
        ) {
          this.isTelevisaoAtiva = 0
          this.player.setVolume(0)
          this.mostrarChamadas = true
        }
      }
    },

    alterarInfoPainelFunc (mensagem) { // adminUnidade
      console.log('em func alterarInfoPainel', mensagem) //  esse variavel para chamar esse metodo : executandoAudioTimeout
      this.modoVisualizacao = mensagem.modoVisualizacao
      if (this.isTelevisao == 0 && mensagem.isTelevisao == 1) {
        this.isTelevisao = 1
        this.isTelevisaoAtiva = 1
        this.link = mensagem.link
        this.volumeVideo = mensagem.volume
        this.volume = mensagem.volume
        this.nomeVideo = mensagem.nomeVideo // added
        this.idVideo = mensagem.idVideo // added
        this.disponivel = 1 // added
        this.chamouVideoOffline = false // added
        this.player.loadVideoById(this.link)
        this.player.setVolume(this.volumeVideo)
        this.mostrarChamadas = false
        const _this = this
        setTimeout(() => {
          _this.verificaEstadoVideoSocket()
        }, 5000)
      } else if (this.isTelevisao == 1 && mensagem.isTelevisao == 0) {
        this.isTelevisao = 0
        this.isTelevisaoAtiva = 0
        this.link = mensagem.link
        this.player.pauseVideo()
        this.disponivel = 0 // added
        this.idVideo = mensagem.idVideo // added
        this.player.setVolume(0)
        clearInterval(this.intervalMostrarChamadas)
        this.mostrarChamadas = true
      } else if (this.isTelevisao == 1 && mensagem.isTelevisao == 1) {
        if (this.link != mensagem.link) {
          this.link = mensagem.link
          this.nomeVideo = mensagem.nomeVideo // added
          this.idVideo = mensagem.idVideo // added
          this.disponivel = 1 // added
          this.chamouVideoOffline = false // added
          this.volumeVideo = mensagem.volume
          this.volume = mensagem.volume
          this.player.loadVideoById(this.link)
          // this.player.setVolume(this.volumeVideo)
        } else {
          this.volumeVideo = mensagem.volume
          this.volume = mensagem.volume
        }
        this.isTelevisaoAtiva = 1
        this.mostrarChamadas = false
      }
    },

    chamarSocket () {
      console.log('em chamar socket')
      this.socket.on(
        'alterarInfoPainel',
        function (mensagem) {
          console.log('skt alterarInfoPainel', mensagem)
          if (this.user.username == mensagem.username) {
            let espera = setInterval(isLoaded, 1000)
            const _this = this

            function isLoaded () {
              if (!_this.executandoAudioTimeout) {
                clearInterval(espera)
                _this.alterarInfoPainelFunc(mensagem)
              }
            }
          }
        }.bind(this)
      )

      this.socket.on(
        'alterarVideo',
        function (mensagem) {
          console.log('skt alterarVideo', mensagem) // recebe idVideo e Link do adminDev

          if (this.isTelevisao) {
            // se id video for igual ao meu eu troco o link
            if (
              this.idVideo == mensagem.idVideo &&
              this.link != mensagem.link
            ) {
              this.link = mensagem.link
              this.nomeVideo = mensagem.nomeVideo
              this.idVideo = mensagem.idVideo
              this.isTelevisaoAtiva = 1
              this.chamouVideoOffline = false // added
              this.disponivel = 1 // added
              this.player.loadVideoById(this.link)
              this.player.setVolume(this.volumeVideo)
              this.mostrarChamadas = false
              setTimeout(() => {
                this.verificaEstadoVideoSocket()
              }, 5000)
            }
          }
        }.bind(this)
      )

      this.socket.on(
        'medicoOnline',
        function (mensagem) {
          console.log('skt medicoOnline')
          console.log(mensagem)
          if (!this.notificacaoMedicoOnline) {
            this.notificacaoMedicoOnline = true
            this.mensagemNomeMedicoNotificacao = mensagem.nomeMedico
            this.mensagemNomeLocalNotificacao = mensagem.nomeLocal
            this.mensagemTecnicoNotificacao = mensagem.tecnico
            setTimeout(() => {
              this.notificacaoMedicoOnline = false
            }, 8000)
          } else {
            this.filaNotificacaoMedicoOnline.push(mensagem)
          }
        }.bind(this)
      )

      this.socket.on(
        'chamando',
        function (mensagem) {
          console.log('skt chamando', mensagem)
          if (!mensagem.codigoSigla) {
            mensagem.codigoSigla = this.mapearLetraPrioridade(mensagem.prioridade)
          }
          if (this.modoVisualizacao !== 'medico') { // passa se for recepcao ou recepcao-medico
            if (
              this.listaChamadas.length > 0 &&
              !this.executandoAudioTimeout &&
              this.listaChamadas[0].codigo == mensagem.codigo &&
              this.listaChamadas[0].guiche == mensagem.guiche
            ) {
              this.executandoAudioTimeout = true
              this.greet(1)
            } else if (!this.executandoAudioTimeout) {
              this.executandoAudioTimeout = true
              this.listaChamadas.unshift(mensagem)
              this.greet(1)
            } else if (
              this.executandoAudioTimeout &&
              !this.executandoListaAudio1
            ) {
              console.log('add skt listaAudio1')
              this.listaAudio1.push(mensagem)
            } else if (
              this.executandoAudioTimeout &&
              this.executandoListaAudio1
            ) {
              console.log('add skt listaAudio2')
              this.listaAudio2.push(mensagem)
            }
          }
        }.bind(this)
      )

      this.socket.on(
        'chamandoPaciente',
        function (mensagem) {
          console.log('skt chamando mensagens: ', mensagem)
          if (!mensagem.codigoSigla) {
            mensagem.codigoSigla = this.mapearLetraPrioridade(mensagem.prioridade)
          }

          if (this.modoVisualizacao !== 'recepcao') { // // passa se for medico ou recepcao-medico
            console.log('skt chamandoPaciente', mensagem)
            if (
              this.listaChamadas.length > 0 &&
              !this.executandoAudioTimeout &&
              this.listaChamadas[0].tipoChamada == mensagem.tipoChamada &&
              this.listaChamadas[0].codigo == mensagem.codigo &&
              this.listaChamadas[0].nomePaciente == mensagem.nomePaciente &&
              this.listaChamadas[0].nomeMedico == mensagem.nomeMedico &&
              this.listaChamadas[0].local == mensagem.local &&
              this.listaChamadas[0].nomeConsultorio == mensagem.nomeConsultorio
            ) {
              this.executandoAudioTimeout = true
              this.greet(2)
            } else if (!this.executandoAudioTimeout) {
              this.executandoAudioTimeout = true
              this.listaChamadas.unshift(mensagem)
              this.greet(2)
            } else if (
              this.executandoAudioTimeout &&
              !this.executandoListaAudio1
            ) {
              console.log('add skt listaAudio1')
              this.listaAudio1.push(mensagem)
            } else if (
              this.executandoAudioTimeout &&
              this.executandoListaAudio1
            ) {
              console.log('add skt listaAudio2')
              this.listaAudio2.push(mensagem)
            }
          }
        }.bind(this)
      )

      // informações sobre a conexão de dados usando socket
      this.socket.on(
        'connect',
        function (mensagem) {
          this.mensagemNotificacaoSocket = 'conectado'
          this.chamarModalConexao()
        }.bind(this)
      )

      this.socket.on('connect_error', () => {
        this.mensagemNotificacaoSocket = 'aguardando conexao'
        this.chamarModalConexao()
      })

      this.socket.on(
        'disconnect',
        function () {
          this.mensagemNotificacaoSocket = 'desconectado'
          this.chamarModalConexao()
        }.bind(this)
      )
    },
    // delay

    listenForSpeechEvents () {
      this.greetingSpeech.onstart = () => {
        this.executandoAudio = true
      }

      this.greetingSpeech.onend = () => {
        this.executandoAudio = false
      }

      this.greetingSpeech.onerror = () => {
        console.log('onerror greetingSpeech !!!')
        if (!this.mandouMsgErroAudio) {
          this.mandouMsgErroAudio = true
          this.audioError('localTeste', 'usernameTeste')
        }
      }
    },

    mapearLetraPrioridade (prioridade) {
      if (prioridade === 0) {
        return 'C'
      } else if (prioridade === 1) {
        return 'P'
      } else if (prioridade === 2) {
        return 'B'
      } else if (prioridade === 3) {
        return 'A'
      }
      return ''
    },

    logout () {
      console.log('em logout..')
      // this.$router.push("/login");
      this.$store
        .dispatch('FedLogOut')
        .then(rsp => {
          console.log('log out')
          this.limparIntervalos()
          this.socket ? (this.socket.close(), this.socket.disconnect()) : ''
          this.$router.push('/login')
          if (r) { }
        })
        .catch(error => { })
    },
    iniciarContador () {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var s = today.getSeconds()
      m < 10 ? (m = '0' + m) : m
      s < 10 ? (s = '0' + s) : s
      this.currentTime = h + ':' + m + ':' + s
    },

    addMensagensVisorDelay () {
      // chmar essa funcao a cada 5 segundos
      // console.log('em add mensagem visor..');
      if (!this.executandoAudioTimeout) {
        if (this.fila1MensagensVisor.length) {
          this.fila1MensagensVisor.forEach((element, index) => {
            setTimeout(() => {
              console.log('delay')
              this.listaChamadas.unshift(element)
              this.greet(1)
            }, 1000)
          })
          this.fila1MensagensVisor = []
        } else {
          if (this.fila2MensagensVisor.length) {
            this.fila2MensagensVisor.forEach((element, index) => {
              setTimeout(() => {
                console.log('delay')
                this.listaChamadas.unshift(element)
                this.greet(2)
              }, 1000)
            })
            this.fila2MensagensVisor = []
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.player {
  height: 90vh;
}

/* div.chamada_automatica {
  font-size: 100px;
} */

.rouded_card_local {
  border-radius: 30px;
  background: #26a69a;
  border-color: white;
}

.rounded-border {
  border-radius: 10px;
}
</style>
